import React from 'react';
import type {
  StatusRow,
  StatusType,
} from '../Dialogs/Statuses/StatusesTable.types';
import { useGetStatuses } from '../Dialogs/Statuses/useGetStatuses';
import { StatusChip } from '../StatusChip';
import { EditableAutocomplete } from './EditableAutocomplete';

interface EditableContainerStatusAutocompleteProps {
  value: any;
  onChange: (value: any) => void;
  onSave: (value: any) => void;
  onCancel: () => void;
  rowData?: any;
  disableClearable?: boolean;
}

const getStatusLabel = (option: StatusRow | string): string =>
  typeof option === 'string' ? option : option?.name || '';

export const EditableContainerStatusAutocomplete: React.FC<
  EditableContainerStatusAutocompleteProps
> = ({ rowData, disableClearable = false, ...props }) => {
  const kind: StatusType =
    rowData?.tradeType === 'EXPORT' ? 'EXPORT' : 'IMPORT';

  return (
    <EditableAutocomplete<StatusRow, Record<string, never>>
      {...props}
      disableClearable={disableClearable}
      useApiHook={useGetStatuses}
      getterName='getStatuses'
      additionalDependency={kind}
      defaultParams={{}}
      filterOptions={(opts) => opts.filter((opt) => opt.enabled)}
      getOptionLabel={getStatusLabel}
      isOptionEqualToValue={(option, selectedValue) =>
        option?.id ===
        (typeof selectedValue === 'object' ? selectedValue?.id : selectedValue)
      }
      renderOption={(optionProps, option) => (
        <li {...optionProps} key={option.id}>
          <StatusChip name={option.name} color={option.color} />
        </li>
      )}
      width={160}
    />
  );
};
